import { render, staticRenderFns } from "./CallTechnologyDetails.vue?vue&type=template&id=535f6ba8"
import script from "./CallTechnologyDetails.vue?vue&type=script&lang=js"
export * from "./CallTechnologyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports